import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from "react";
import { cn } from "@/lib/utils";
export const WpGraphQLIcon = t0 => {
  const $ = _c(10);
  let className;
  let svg;
  if ($[0] !== t0) {
    ({
      className,
      ...svg
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = svg;
  } else {
    className = $[1];
    svg = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("size-12", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <g clipPath="url(#clip0_2932_1774)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#0E2339" /><path d="M5.51232 14.1041C5.51232 12.457 5.53951 12.2559 5.84391 11.6525C6.11026 11.1306 6.81695 10.4783 7.28448 10.3369C7.38774 10.3043 7.42037 10.3532 7.59976 10.799C8.18138 12.2613 9.33929 13.354 10.8505 13.8595L11.2473 13.9954L11.2636 14.7836C11.269 15.2239 11.2582 15.5773 11.2364 15.5718C11.2092 15.5718 11.1005 15.4251 10.9809 15.2457C10.421 14.3705 9.30666 13.8377 8.18138 13.903C7.15941 13.9628 6.27877 14.4683 5.70802 15.3163L5.51232 15.6045V14.1041ZM6.69193 18.105C7.1649 17.9637 7.52363 17.469 7.52363 16.958C7.52363 16.5938 7.96941 16.1752 8.3499 16.1752C8.8337 16.1752 9.16534 16.5014 9.23054 17.0396C9.29035 17.5233 9.49149 17.8278 9.88829 18.0398C10.0949 18.154 10.1764 18.1594 11.4104 18.1594C12.6498 18.1594 12.7259 18.154 12.9379 18.0398C13.1988 17.8984 13.4869 17.594 13.5413 17.382C13.5685 17.3005 13.5848 16.2078 13.5848 14.9521V12.669L13.4489 12.4298C13.2206 12.0275 12.9596 11.8862 12.3019 11.7992C11.4104 11.6851 10.8939 11.4459 10.3775 10.9186C9.99704 10.5381 9.67627 9.90751 9.58932 9.36934C9.41541 8.34194 9.92635 7.18951 10.8233 6.59153C11.3614 6.23275 11.7855 6.1023 12.4161 6.1023C12.8292 6.1023 13.0086 6.12948 13.3184 6.23823C14.0088 6.48283 14.5252 6.89594 14.8894 7.5048C15.2754 8.15711 15.2645 7.98315 15.2971 11.9351C15.3243 15.1641 15.3406 15.5229 15.4276 15.7947C15.7157 16.6862 16.3137 17.4146 17.0421 17.768C18.0423 18.2572 19.0208 18.2898 19.8906 17.8658C20.7821 17.4255 21.4725 16.4307 21.6573 15.3163C21.7714 14.6314 21.6029 14.2292 21.1028 13.9791C20.619 13.7344 20.0754 13.7997 19.7384 14.1422C19.5209 14.3596 19.4448 14.5227 19.3524 14.9793C19.2328 15.5447 18.9719 15.7947 18.4935 15.7947C18.1945 15.7947 17.9064 15.6425 17.7705 15.4088C17.6672 15.2294 17.6618 15.0989 17.6346 11.7177C17.6074 8.5974 17.5966 8.16798 17.5096 7.83639C16.9279 5.59131 15.1938 4.06923 12.8835 3.78109C11.7311 3.63976 10.2144 4.10186 9.18704 4.92269C8.36077 5.575 7.8226 6.35776 7.4747 7.40692L7.31162 7.87445L6.75174 8.07555C5.86018 8.39087 5.40901 8.66809 4.74038 9.31497C4.13701 9.90208 3.71841 10.5544 3.44663 11.3372C3.19655 12.0765 3.1748 12.3374 3.1748 14.8923V17.3005L3.29987 17.5397C3.4412 17.806 3.77279 18.067 4.05001 18.1322C4.15332 18.154 4.72407 18.1757 5.32749 18.1811C6.14832 18.1865 6.48535 18.1648 6.69193 18.105ZM12.889 10.0053C13.1716 9.88576 13.2804 9.77706 13.4271 9.46173C13.6391 9.01056 13.5794 8.49958 13.2695 8.14623C13.0466 7.89076 12.8237 7.80376 12.3998 7.80376C12.1171 7.80376 12.0138 7.83095 11.8073 7.96141C11.1005 8.40719 11.1386 9.59219 11.8724 9.96728C12.1606 10.1087 12.5955 10.1249 12.889 10.0053Z" fill="#F9921E" /></g>;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <defs><clipPath id="clip0_2932_1774"><rect width="24" height="24" fill="white" /></clipPath></defs>;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== svg || $[8] !== t1) {
    t4 = <svg viewBox="0 0 24 24" fill="none" role="img" className={t1} xmlns="http://www.w3.org/2000/svg" {...svg}>{t2}{t3}</svg>;
    $[7] = svg;
    $[8] = t1;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
WpGraphQLIcon.displayName = "WPGraphQLIcon";